import React from 'react';

// StepProduct — pick which gift-card product to buy. Only rendered when the
// salon sells more than one online voucher product.
const StepProduct = ({ vouchers, selectedVoucherId, currency, onChange }) => (
  <section className="gcs-step">
    <div className="gcs-product-list">
      {vouchers.map((v) => {
        const from = v.denominations && v.denominations.length
          ? Math.min(...v.denominations)
          : v.value;
        const active = v.id === selectedVoucherId;
        return (
          <button
            key={v.id}
            type="button"
            className={`gcs-product ${active ? 'is-active' : ''}`}
            onClick={() => onChange(v.id)}
            aria-pressed={active}
          >
            <span className="gcs-product-name">{v.name}</span>
            <span className="gcs-product-from">From {currency}{from}</span>
          </button>
        );
      })}
    </div>
  </section>
);

export default StepProduct;
